const backgroundImagesFileNames = [
  "signin-bg-1.jpg",
  "signin-bg-2.jpg",
  "signin-bg-3.jpg",
  "signin-bg-4.jpg",
  "signin-bg-5.jpg"
];

export function getBackgroundImgUrl() {
  const imgsCount = backgroundImagesFileNames.length;
  const imgNum = Math.floor(Math.random() * imgsCount);
  const imgFilename = backgroundImagesFileNames[imgNum];
  return `assets/backgrounds/${imgFilename}`;
}
